const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    padding: '20px 20px 20px 30px',
    position: 'relative',
    borderBottom: '1px solid #DFE2E5',
  },
  activeWrapper: {
    backgroundColor: 'hsla(0, 0%, 0%, .1)',
  },
  unreadWrapper: {
    backgroundColor: 'hsla(345, 100%, 78%, .1)',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: 18,
  },
  description: {
    fontSize: 14,
    color: '#7C7C7C',
    marginTop: 8,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '80%',
    height: 14,
    lineHeight: '14px',
  },
  rightBottomText: {
    position: 'absolute',
    fontSize: 10,
    color: '#7C7C7C',
    right: 5,
    bottom: 5,
  },
  leftTopIcon: {
    position: 'absolute',
    top: 5,
    left: 5,
    transition: 'all .3s',
    '&:hover': {
      transform: 'scale(1.2)',
      stroke: 'hsl(350, 83%, 60%)',
      fill: 'hsl(350, 83%, 60%)',
    },
  },
}
export default styles
